import React from "react";

export const Switch = ({ isToggled, onClick }) => {
    return (
      <label className="switch">
        <input type="checkbox" checked={isToggled} onChange={onClick} />
        <span className="slider round"></span>
      </label>
    );
  };